export function phoneNumber2ReadableFormat(phoneNumber: string): string {
  const areaCode = phoneNumber.slice(0, 3);
  const regionCode = phoneNumber.slice(3, 6);
  const remainder = phoneNumber.slice(6);

  return `(${areaCode}) ${regionCode}-${remainder}`;
}
